import { useMutation, ApolloError } from '@apollo/client'

import { MUTATION_CREATE_USER } from '@libs/apollo/mutations'
import { USERS } from '@libs/apollo/queries'

import { User, UserCreateInput, MutationCreateUserArgs } from '@types'

interface Data {
  createUser: User
}

export const useCreateUser = (): {
  createUser: (input: UserCreateInput) => void
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [createUser, { loading, error, data }] = useMutation<Data, MutationCreateUserArgs>(MUTATION_CREATE_USER, {
    notifyOnNetworkStatusChange: true,
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: USERS,
        variables: {
          input: {
            email: undefined,
          },
          pagination: { first: 20, after: undefined },
        },
      },
    ],
  })

  const create = (input: UserCreateInput) => {
    createUser({ variables: { input } })
  }

  return { createUser: create, loading, error, data }
}
